<script>
  import { _ } from 'svelte-i18n'
  import { fade } from 'svelte/transition'
  let hidden = localStorage.getItem('cookie_notice') || false

  function dismiss() {
    hidden = true
    localStorage.setItem('cookie_notice', 'true')
  }
</script>

{#if !hidden}
  <div 
    class="notice"
    transition:fade="{{duration: 200}}">
    <button on:click={dismiss}>&times;</button>
    {$_('cookies.weUse')}<a href="/privacy/" target="blank">{$_('cookies.pp')}</a>
  </div>
{/if}

<style>
div {
  position: absolute;
  right: 6rem;
  bottom: 2.5rem;
  height: 3rem;
  line-height: 2rem;
  padding: 0.5rem 4rem 0.5rem 1.25rem;
  font-size: 1.4rem;
  letter-spacing: 0.1px;
  color: var(--c-text-faded);
  background-color: var(--c-flash-bg);
  border-radius: var(--border-radius);
}

div button {
  position: absolute;
  top: 0;
  right: 0;
  width: 3rem;
  line-height: 3rem;
  font-size: 2rem;
  color: var(--c-text-faded);
  background: none;
  border: none;
  outline: none;
  border-left: 1px solid var(--c-accent-fill);
}

div a {
  color: var(--c-text-on-fill);
  text-decoration: none;
  opacity: 0.85;
}

div button:hover,
div a:hover {
  color: var(--c-text-on-fill-hover);
  opacity: 1;
}

@media only screen and (max-width: 864px) {
  div {
    right: 4rem;
    width: 16rem;
    height: auto;
    padding-right: 1rem;
  }
  div button {
    border-left: none;
  }
}
</style>